// extracted by mini-css-extract-plugin
export var formContainer = "_d3-0";
export var message = "_d3-1";